module.exports = __webpack_public_path__ + "img/ob_02.e8b3595d.jpg";